<template>
  <mask-layer class="selection" @input="closeHandle">
    <div class="content">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item class="form-item">
          <el-input
            clearable
            v-model="keyword"
            @input="searchHandle"
            placeholder="搜索关键字(姓名、手机号)"
            prefix-icon="el-icon-search"
            style="width:300px">
          </el-input>
        </el-form-item>
        <el-form-item class="form-item">
          <el-button type="primary" icon="el-icon-search" @click="searchHandle">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-button
        type="success"
        size="mini"
        :disabled="selection.length===0"
        @click="confirmHandle">确认选择</el-button>
      </el-row>
      <table-component
        :table-data="tableData"
        :page="page"
        :total="total"
        :size="per_page"
        @current-change="currentPageChange"
        @selection-change="selectionChange">
      </table-component>
    </div>
  </mask-layer>
</template>
<script>
import TableComponent from '@/components/Table'
import MaskLayer from '@/components/MaskLayer'
import request from '@/utils/request'
export default {
  name: 'Selection',
  props: ['sendData', 'url'],
  data () {
    return {
      keyword: '',
      page: 1,
      per_page: 10,
      total: 0,
      userList: [],
      selection: []
    }
  },
  components: {
    TableComponent,
    MaskLayer
  },
  watch: {
    sendData: function () {
      this.page = 1
      this.tableData.list = []
      this.getUserList()
    }
  },
  methods: {
    searchHandle () {
      this.page = 1
      this.getUserList()
    },
    closeHandle (e) {
      this.$emit('input', false)
    },
    getUserList () {
      if (!this.sendData) {
        return
      }
      this.sendData.per_page = this.per_page
      this.sendData.page = this.page
      if (this.keyword !== '') {
        this.sendData.key = this.keyword
      }
      let _this = this
      request({
        url: this.url,
        method: 'get',
        params: this.sendData
      }).then(res => {
        _this.total = res.data.item_total
        _this.userList = res.data.list
      })
    },
    currentPageChange (e) {
      this.page = e
      this.getUserList()
    },
    selectionChange (e) {
      this.selection = e
    },
    confirmHandle () {
      this.$emit('confirm', this.selection)
    }
  },
  computed: {
    tableData: function () {
      return {
        type: 'user',
        props: [
          {
            label: '头像',
            type: 'img',
            prop: 'headimg',
            width: '120'
          },
          {
            label: '名称',
            type: 'string',
            prop: 'name'
          },
          {
            label: '性别',
            type: 'string',
            prop: 'gender'
          },
          {
            label: '手机号',
            type: 'string',
            prop: 'phone'
          },
          {
            label: '积分',
            type: 'string',
            prop: 'score'
          },
          {
            label: '注册日期',
            type: 'string',
            prop: 'created_at'
          }
        ],
        list: this.userList,
        selection: true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 1000px;
}
.form-item {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Selection/index.vue